import React, { useState, Fragment, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Button,
  Avatar,
  Box,
  Badge,
  Menu,
  List,
  ListItem,
  Divider,
  Collapse,
  Typography,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import Tooltip from '../components/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getService } from 'reducers/service';
import {
  setNavigationDrawerMobileState,
  setEventsDrawerMobileState,
  setUnitsDrawerMobileState,
} from '../reducers/UiReducer';
import { setMode } from '../reducers/ThemeReducer';
import { setUserAuthenticated, USER_SET_PERMISSION } from '../reducers/UserReducer';
import menuItems from '../config/configureMenu';
import settings from '../config/settings';
import { addPageDialog, openSettings, addPerson } from '../reducers/DialogsReducer';
import AboutDialog from './AboutDialog';
import Clock from './Clock';
import store from '../config/configureStore';
import { removePermissions, setPermissions } from 'reducers/PermissionCheckReducer';
import { ListItemButton, ListItemText, Switch, ListItemIcon } from '@mui/material';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import TuneIcon from '@material-ui/icons/Tune';
import KeyIcon from '@material-ui/icons/VpnKey';
import SchoolIcon from '@material-ui/icons/School';
import RestartAltIcon from '@material-ui/icons/SettingsBackupRestore';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import InfoIcon from '@material-ui/icons/Info';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import DarkModeIcon from '@material-ui/icons/Brightness2';
import ImageIcon from '@material-ui/icons/Image';
import ReleaseNotesDialog from './ReleaseNotesDialog';
import ChangePasswordDialog from './ChangePasswordDialog';
import { notify } from 'reducers/NotifierReducer';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  leftMenu: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    '& button': {
      '& span': {
        marginRight: 8,
      },
    },
  },
  rightMenu: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.topNav.bg,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  toolbar: {
    height: settings.mainNavHeight,
    minHeight: settings.mainNavHeight,
    backgroundColor: theme.palette.bgElements,
  },
  btn: {
    width: '85px',
    height: '60px',
    border: '3px solid rgba(1, 83, 163, 0.5) !important',
  },
  btnLabel: {
    position: 'absolute',
    bottom: -3,
    left: 0,
    right: 0,
    textAlign: 'center',
  },
  activeNav: {
    '& > li': {
      fontWeight: 600,
    },
  },
  userName: {
    color: theme.colors.text1,
    marginLeft: 8,
  },
  arrowDn: {
    color: theme.colors.text1,
    marginLeft: 8,
  },
  fullWidthMenu: {
    zIndex: 2,
    position: 'absolute',
    top: settings.mainNavHeight,
    left: 0,
    right: 0,
    width: '100%',
    padding: `${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`,
  },
  searchMenu: {
    display: 'flex',
    '& h5': {
      paddingLeft: theme.spacing(2),
    },
    '& svg': {
      marginRight: theme.spacing(1),
      fontSize: 16,
      opacity: 0.25,
    },
    '& a': {
      color: theme.colors.text1,
    },
    '& a:hover': {
      color: theme.colors.text1,
    },
  },
  fwMenuWrap: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    zIndex: 2,
  },
}));

const UserBadge = withStyles({
  badge: {
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
})(Badge);

const MainNav = (props) => {
  const classes = useStyles();
  const { setMode, setUserAuthenticated, network, user, themeMode } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [displayAbout, setDisplayAbout] = useState(false);
  const [userName, setUserName] = useState('');
  const [searchMenuVisible, setSearchMenuVisible] = useState(false);
  const {
    inmatesAccess,
    inmatesCreateLineups,
    inmatesViewOnly,
    employeeViewOnly,
    employeeAccess,
    employeeCreateLineups,
    usersAdmin,
  } = useSelector((state) => state.Permissions);

  const history = useHistory();
  const dispatch = useDispatch();

  const [displayReleaseNotes, setDisplayReleaseNotes] = useState(false);
  const [displayChangePass, setDisplayChangePass] = useState(false);
  const [openAppSubmenu, setOpenAppSubmenu] = useState(false);
  const [openOptionSubmenu, setOpenOptionSubmenu] = useState(false);
  const [openCacheClearConfirmation, setOpenCacheClearConfirmation] = useState(false);

  const handleOptionClick = () => {
    setOpenOptionSubmenu((prev) => !prev);
  };

  const redirectToApp = (url) => {
    if (url) {
      const newWindow = window.open(url, '_blank');
    } else {
      dispatch(notify('Please set the proper link in configuration.', 'error'));
    }
  };

  const closeReleaseNotes = () => {
    setDisplayReleaseNotes(false);
  };

  const showReleaseNotes = () => {
    setDisplayReleaseNotes(true);
    handleClose();
  };

  const closeChangePass = () => {
    setDisplayChangePass(false);
  };

  const showChangePass = () => {
    setDisplayChangePass(true);
    handleClose();
  };

  const getHelpUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Help',
      CDRKey: 'HelpLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getTrainingUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Training',
      CDRKey: 'TrainingLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const handleClearCache = () => {
    setOpenCacheClearConfirmation(true);
  };

  const handleConfirmationClick = () => {
    const auth = localStorage.getItem('auth');
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem('auth', auth);
    //history.push('/');
    window.location.reload();
  };

  const handleCloseDialog = () => {
    setOpenCacheClearConfirmation(false);
  };

  useEffect(() => {
    if (user.userData && user.userData.user) {
      let name = user.userData.user.Username;
      if (name !== userName) setUserName(name);
    }
    // eslint-disable-next-line
  }, [user]);

  const handleAboutClick = () => {
    setAnchorEl(null);
    setDisplayAbout(!displayAbout);
  };
  const handleCatagoriesClick = () => {
    setAnchorEl(null);
    history.push('/image-types');
  };

  const handleOpenSettings = () => {
    setAnchorEl(null);
    props.openSettings();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleReloadCodesAndPermissionsClick = async () => {
    const currentUserId = store.store.getState().user?.userData?.user?.picUserID;
    const service = getService('pic-users-permissions');
    const userPermissions = await service
      .get(currentUserId)
      .then((res) => res.map((permission) => permission.picPermissionID));
    const permissionsService = getService('pic-permissions');
    const perms = await permissionsService.find();
    const latestPermissions = [];
    const permissionsToRemove = [];
    perms.forEach((permission) => {
      if (userPermissions.includes(permission.picPermissionID)) {
        latestPermissions.push({ Code: permission.Code });
      } else {
        permissionsToRemove.push({ Code: permission.Code });
      }
    });
    dispatch(setPermissions(latestPermissions));
    dispatch(removePermissions(permissionsToRemove));
    dispatch({ type: USER_SET_PERMISSION, payload: latestPermissions });
    handleClose();
  };

  const StyledBadge = withStyles({
    badge: {
      backgroundColor: network.online === false ? 'var(--danger)' : 'var(--success)',
      color: network.online === false ? 'var(--danger)' : 'var(--success)',
    },
  })(UserBadge);

  const handleUserMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const toggleColorMode = () => {
    setMode();
    handleClose();
  };

  const renderUserMenu = () => {
    return (
      <Menu
        anchorEl={anchorEl}
        keepMounted
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
        transformOrigin={{ vertical: 'center', horizontal: 'center' }}
        onClose={handleClose}
        className="ml-2">
        <div className="dropdown-menu-right dropdown-menu-xxl overflow-hidden p-0">
          <List className="text-left bg-transparent pt-0">
            <Box className="text-center">
              <StyledBadge
                overlap="circle"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                variant="dot">
                <Avatar sizes="44" alt={userName} />
              </StyledBadge>
            </Box>
            <div>
              <div className="font-weight-bold text-center pt-2 line-height-1">{userName}</div>
            </div>
            <Divider className="w-100 mt-2" />
            <ListItemButton>
              <ListItemIcon>
                {themeMode !== 'day' ? (
                  <WbSunnyIcon />
                ) : (
                  <DarkModeIcon style={{ transform: 'rotate(150deg)' }} />
                )}
              </ListItemIcon>
              <ListItemText primary={themeMode !== 'day' ? 'Light Modes' : 'Dark Mode'} />
              <Switch checked={themeMode !== 'day'} onChange={toggleColorMode} />
            </ListItemButton>

            <ListItemButton button onClick={handleOptionClick}>
              <ListItemIcon>
                <TuneIcon />
              </ListItemIcon>
              <ListItemText primary="Options" />
              {openOptionSubmenu ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openOptionSubmenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 5 }} onClick={showChangePass} button>
                  <ListItemIcon>
                    <KeyIcon />
                  </ListItemIcon>
                  <ListItemText primary="Change Password" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 5 }}
                  onClick={handleReloadCodesAndPermissionsClick}
                  button>
                  <ListItemIcon>
                    <RestartAltIcon />
                  </ListItemIcon>
                  <ListItemText primary="Reload Codes & Permissions" />
                </ListItemButton>
                <ListItemButton sx={{ pl: 5 }} onClick={handleClearCache} button>
                  <ListItemIcon>
                    <DeleteSweepIcon />
                  </ListItemIcon>
                  <ListItemText primary="Clear Cache" />
                </ListItemButton>
                <ListItemButton sx={{ pl: 5 }} onClick={handleCatagoriesClick} button>
                  <ListItemIcon>
                    <ImageIcon />
                  </ListItemIcon>
                  <ListItemText primary="Image Types" />
                </ListItemButton>
              </List>
            </Collapse>

            <ListItemButton onClick={getTrainingUrl} button>
              <ListItemIcon>
                <SchoolIcon />
              </ListItemIcon>
              <ListItemText primary="Training Academy" />
            </ListItemButton>
            <ListItemButton onClick={getHelpUrl} button>
              <ListItemIcon>
                <HelpOutlineIcon />
              </ListItemIcon>
              <ListItemText primary="Help" />
            </ListItemButton>

            <ListItemButton button onClick={showReleaseNotes}>
              <ListItemIcon>
                <NewReleasesIcon />
              </ListItemIcon>
              <ListItemText primary="Release Notes" />
            </ListItemButton>

            <ListItemButton button onClick={handleAboutClick}>
              <ListItemIcon>
                <InfoIcon />
              </ListItemIcon>
              <ListItemText primary="About" />
            </ListItemButton>

            {/* <ListItem onClick={handleCatagoriesClick} button>
              Image Types
            </ListItem> */}
            {/* <ListItem onClick={handleAboutClick} button>
              About
            </ListItem> */}
            {/* <ListItem onClick={handleOpenSettings} button>
              Settings
            </ListItem>*/}
            <Divider className="w-100" />
            <ListItem className="d-block rounded-bottom px-3 pt-3 pb-0 text-center">
              <Button
                onClick={() => setUserAuthenticated(false)}
                variant="outlined"
                size="medium"
                color="default">
                <span className="btn-wrapper--icon">
                  <FontAwesomeIcon icon={['fas', 'sign-out-alt']} />
                </span>
                <span className="btn-wrapper--label">Logout</span>
              </Button>
            </ListItem>
          </List>
          <Dialog open={openCacheClearConfirmation} onClose={handleCloseDialog} maxWidth="md">
            <DialogTitle style={{ background: '#2871cc', color: 'white' }}>
              {<Typography variant="h5">Confirmation!</Typography>}
            </DialogTitle>
            <DialogContent style={{ display: 'flex', alignItems: 'center' }}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    component="div"
                    style={{ marginTop: 10 }}>
                    Clearing the cache will log you out of the system. You will lose all unsaved
                    progress. Do you wish to proceed?
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <div className="mb-1">
                <Button
                  onClick={handleConfirmationClick}
                  style={{
                    background: '#2871cc',
                    color: '#fff',
                    width: '80px',
                    marginRight: '5px',
                  }}>
                  Yes
                </Button>
                <Button
                  onClick={handleCloseDialog}
                  style={{ background: '#2871cc', color: '#fff', width: '80px' }}>
                  No
                </Button>
              </div>
            </DialogActions>
          </Dialog>
        </div>
      </Menu>
    );
  };

  const renderDesktopMenu = () => {
    return (
      <div className={classes.wrapper}>
        <div className={classes.leftMenu}>
          <div>
            {menuItems.map((btn, idx) => {
              if (btn.label == 'LINEUPS') {
                if (!(inmatesCreateLineups && inmatesAccess && !inmatesViewOnly)) {
                  return;
                }
              }
              if (btn.label == 'ADMINISTRATION') {
                if (!usersAdmin) {
                  return;
                }
              }
              return (
                <Tooltip title={btn.tooltip} key={idx}>
                  <NavLink to={btn.link} activeClassName={classes.activeNav}>
                    <Button>{btn.label}</Button>
                  </NavLink>
                </Tooltip>
              );
            })}
          </div>
        </div>

        <div className={classes.rightMenu}>
          <div className="mr-3">
            <Clock />
          </div>
          <div>
            <Button
              color="inherit"
              onClick={handleUserMenuClick}
              className="text-capitalize px-3 text-left btn-inverse d-flex align-items-center">
              <Box className={classes.avatar}>
                <Avatar sizes="30" alt={userName} />
              </Box>
              <span className={classes.userName}>{userName}</span>
              <span className={classes.arrowDn}>
                <FontAwesomeIcon icon={['fas', 'angle-down']} className="opacity-5" />
              </span>
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <AppBar color="primary" position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          {renderDesktopMenu()}
          {renderUserMenu()}
        </Toolbar>
      </AppBar>
      {displayAbout && <AboutDialog close={handleAboutClick} />}
      {displayReleaseNotes && <ReleaseNotesDialog close={closeReleaseNotes} />}
      {displayChangePass && <ChangePasswordDialog close={closeChangePass} />}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  network: state.offline,
  themeMode: state.theme.mode,
  user: state.user,
});

export default connect(mapStateToProps, {
  setNavigationDrawerMobileState,
  setEventsDrawerMobileState,
  setUnitsDrawerMobileState,
  setMode,
  setUserAuthenticated,
  addPageDialog,
  openSettings,
  addPerson,
})(MainNav);
